<template>
  <vxe-modal v-model="visible" :title="title" type="confirm" width="75%" @confirm="confirm">
    <vxe-textarea v-model="value" :auto-size="{ minRows: minRows, maxRows: maxRows }" style="width: 100%"/>
  </vxe-modal>
</template>
<script>

export default {
  name: 'TextAreaModal',
  props: {
    title: { type: String, default: '文本域' },
    minRows: { type: Number, default: 10 },
    maxRows: { type: Number, default: 20 }
  },
  data() {
    return {
      visible: false,
      value: '',
      e: undefined
    }
  },
  methods: {
    open(value, e) {
      this.e = e
      this.value = value
      this.visible = true
    },
    confirm() {
      this.$emit('change', this.value, this.e)
      this.visible = false
    }
  }
}
</script>